/*
  global DataDogService
*/
import { datadogRum } from '@datadog/browser-rum';
import { LogReport, newRelicEvent, playerNewRelicEvent } from '@foxcorp/delta-web-analytics';
import { isStaticRender } from './ContentHelper';

let reportError;
export const EVENT_TYPE_LOGOUT_REFRESH = 'refresh token failure';
export const EVENT_TYPE_ANONYMOUS_LOGIN = 'anonymous login due to profile object not existing';
export const EVENT_TYPE_UNAUTHORIZED = 'invalid accessToken';

const withDataDogEnableCheck = cb => {
  const { dataDog: dataDogConfig } = window.ExternalConfig;
  return (...args) => {
    if (!reportError) {
      reportError = new LogReport({ datadogRum });
    }
    if (!isStaticRender() && DataDogService && dataDogConfig) {
      cb(...args);
    }
  };
};

export const logError = withDataDogEnableCheck((error, errProps) =>
  reportError.reportError(error, errProps),
);

export const logPlayerError = withDataDogEnableCheck((error, errProps) =>
  reportError.reportErrorInPlayer(error, errProps),
);

export const logEvent = (...args) => newRelicEvent(...args);

export const logPlayerEvent = (...args) => playerNewRelicEvent(...args);
